import { gql } from '@apollo/client/core';

export const GET_ALL_SLUGS = gql`
  query GetAllPageSlugs {
    pageAssemblyCollection(limit: 50) {
      items {
        slug
        pageTitle
        order
        isProtected
      }
    }
  }
`;
